var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

/*
    params.model = NarfWeb.Presentation.ViewModels.DigitalSigningOrderViewModel
    params.tokenKey = string
    params.token = string
*/

function DigitalSigningOrderForm(params) {
  if (params === undefined || params.model === undefined) {
    throw 'Digital Signing Order Form requires params.model as DigitalSigningOrderViewModel';
  }

  var self = this;
  var model = params.model;

  var checkedAgencies = $.map(model.Agencies, function(agency) {
    if (agency.Checked) {
      return agency.Id;
    }
  });

  this.tokenKey = params.tokenKey;
  this.token = params.token;
  this.apiEndpoint = model.ApiEndpoint;
  this.user = model.User;
  this.blockId = model.BlockId;

  this.loading = ko.observable(false);
  this.title = ko.observable(model.Title);
  this.formTextTop = ko.observable(model.FormTextTop);
  this.formTextMiddle = ko.observable(model.FormTextMiddle);
  this.formTextBottom = ko.observable(model.FormTextBottom);
  this.consentText = ko.observable(model.FormConsentText);
  this.successUrl = ko.observable(model.SuccessRedirectUrl);
  this.errorText = ko.observable(model.ErrorText);
  this.notAgencyAdminText = ko.observable(model.NotAgencyAdminText);
  this.agencies = ko.observableArray(model.Agencies);

  this.showErrorText = ko.observable(false);
  this.checkedAgencies = ko.observableArray(checkedAgencies);
  this.checkedConsent = ko.observable(false);

  this.checkedNotDisabledAgencies = ko.computed(function() {
    return $.map(self.checkedAgencies(), function(chkAgencyId) {
      return $.map(self.agencies(), function(agency) {
        if (chkAgencyId === agency.Id && !agency.Disabled) {
          return agency.Id;
        }
      });
    });
  });

  this.formSubmittable = ko.computed(function() {
    if (!self.checkedConsent()) {
      return false;
    }

    return self.checkedNotDisabledAgencies().length;
  });
}

DigitalSigningOrderForm.prototype.labelTextForAgency = function(agency) {
  var name = agency.Name;

  if (agency.Disabled && agency.Checked) {
    return name + ' (Har allerede aktivt abonnement)';
  }

  if (agency.Disabled) {
    return name + ' (Ikke tilgjengelig)';
  }

  return name;
};

DigitalSigningOrderForm.prototype.onSubmit = function(data, event) {
  var self = this;

  event.preventDefault();
  this.loading(true);

  var url = this.apiEndpoint;
  var body = {
    user: this.user,
    agencies: this.checkedNotDisabledAgencies(),
    consent: this.checkedConsent(),
    blockId: this.blockId
  };
  body[this.tokenKey] = this.token;

  APIHelper.post(
    url,
    body,
    function(response) {
      if (response.Success) {
        window.location = self.successUrl();
      } else {
        self.showErrorText(true);
        self.loading(false);
      }
    },
    function(response) {
      self.showErrorText(true);
      self.loading(false);
      var location = window.location.href || document.URL;

      APIHelper.post('/api/log/error', {
        message: 'API-error: digital-signing-order-form.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url,
          'requestBody: ' + JSON.stringify(body)
        ]
      });
    }
  );
};

module.exports = DigitalSigningOrderForm;
